module.exports = __webpack_public_path__ + "static/media/Mtek512x512.9f4596bc.png";